import styled from "styled-components";

export const ContainerModalTagsDestaque = styled.div`
  padding: 8rem 12rem;

  .loading {
    text-align: center;
    color: ${(props) => props.theme.colors.tertiary};
    padding: 2rem;
  }

  .linha-pai {
    display: flex;
    justify-content: center;
    .linha {
      margin: 4rem 0;
      height: 2px;
      background-color: ${(props) => props.theme.colors.elements};
      width: 40%;
    }
  }

  .nova-tag {
    text-align: center;
    color: ${(props) => props.theme.colors.primary};
    margin-bottom: 4rem;
    span {
      cursor: pointer;
    }
  }

  .tableContainer {
    > table {
      width: 100%;

      > thead {
        > tr {
          > th {
            .th-wrapper {
              padding: 2rem;
            }

            &:last-child {
              text-align: right;
              .th-wrapper {
                justify-content: flex-end;
              }
            }
          }
        }
      }

      > tbody {
        > tr {
          > td {
            &:last-child {
              text-align: right;
            }
          }
        }
      }
    }
  }

  .nome-tag {
    cursor: pointer;
  }

  .editar {
    color: ${(props) => props.theme.colors.primary};
    cursor: pointer;
    margin-left: 1rem;

    &:hover {
      text-decoration: underline;
    }
  }

  .center {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
`;

export const Botoes = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;

  .cancelar {
    color: ${(props) => props.theme.colors.tertiary};
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    svg {
      fill: ${(props) => props.theme.colors.tertiary};
      transform: rotate(90deg);
    }
  }
`;

export const CriarTagContainer = styled.div`
  padding: 3rem 5rem;

  .titulo {
    text-align: center;
    color: ${(props) => props.theme.colors.secondary};
    font-weight: bold;
    margin-bottom: 2rem;
  }

  .texto {
    text-align: center;
    color: ${(props) => props.theme.colors.tertiary};
    margin-bottom: 5rem;
  }

  .inputs {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    justify-content: center;
    align-items: center;
    width: 100%;

    > div {
      width: 100%;
    }
  }

  .remover-tag {
    text-align: center;
    color: ${(props) => props.theme.colors.error || "#e74c3c"};
    cursor: pointer;
    margin-top: 2rem;

    &:hover {
      text-decoration: underline;
    }
  }
`;
